import { COUNTRIES } from '~/common/utils/constants';
import {
  GET_USER_ORDERS_REQUEST,
  GET_USER_ORDERS_SUCCESS,
  GET_USER_ORDERS_FAILURE,
} from '../types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  countryCode: COUNTRIES.US,
  vehicleList: [],
  energyProductList: [],
  enterpriseOrderList: [],
  chargingNotification: false,
  coownerNotification: false,
  showUpgradesFlag: false,
  referralCode: '',
  enterpriseDriverOrders: [],
};

export default (state = initialState, action) => {
  const {
    countryCode = COUNTRIES.US,
    vehicleList = [],
    energyProductList = [],
    enterpriseOrderList = [],
    chargingNotification,
    coownerNotification,
    showUpgradesFlag = false,
    referralCode = '',
    enterpriseDriverOrders = [],
  } = action.payload || {};
  switch (action.type) {
    case GET_USER_ORDERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_USER_ORDERS_SUCCESS:
      return {
        isLoading: false,
        isLoaded: true,
        error: false,
        countryCode,
        vehicleList,
        energyProductList,
        enterpriseOrderList,
        chargingNotification,
        coownerNotification,
        showUpgradesFlag,
        referralCode,
        enterpriseDriverOrders,
      };
    case GET_USER_ORDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: true,
      };
    default:
      return {
        ...state,
      };
  }
};
